module.exports = __webpack_public_path__ + "static/img/register.c828c89f.png";